import { render, staticRenderFns } from "./RemitOneLiveFees.vue?vue&type=template&id=e0b4aa9a"
import script from "./RemitOneLiveFees.vue?vue&type=script&lang=js"
export * from "./RemitOneLiveFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports